import { onBeforeMount } from "vue";
import { useUserStore } from "@/store/user";
import { useRouter } from "vue-router";
import { getCurrentUser } from "vuefire";

export function useOnboardingCheck() {
  const userStore = useUserStore();
  const router = useRouter();

  onBeforeMount(async () => {
    await userStore.getBasicUserData();
    const user = await getCurrentUser();
    if (user && user.emailVerified && !userStore.basic.onboarded) {
      router.replace("/onboarding");
    }
  });
  return;
}
